import { DataGridLayoutGrid, List, ListHeader, ListPageLayout } from 'framework/list';
import { TextField } from 'framework/ui/field';
import useProjectsComplianceService from '../useProjectsComplianceService';
import { ComplianceProjectStatus } from '../types';
import NonCompliantReasonsField from '../shared/fields/NonCompliantReasonsField';
import ProjectComplianceStatusField from '../shared/fields/ProjectComplianceStatusField';
import ProjectControlsSection from './ProjectControlsSection';

const ProjectsComplianceListPage = () => {
  const { search } = useProjectsComplianceService();

  return (
    <List getDataMethod={search} disableUrlUpdate>
      <ListPageLayout header={<ListHeader label="Projects compliance" />}>
        <DataGridLayoutGrid
          expandable
          expandableSection={<ProjectControlsSection />}
          isExpandableItem={(project: ComplianceProjectStatus) => project.controls.length > 0}
          isInitialLoaderPosition
          showPagination={false}
          showTotal={false}
          customEmptyMessage="No project compliance data found"
          rowProps={{
            sxRowContainer: {
              border: 0,
              my: 0,
              borderBottom: '1px solid var(--mui-palette-TableCell-border)',
              maxHeight: '100%',
            },
            sx: {
              alignItems: 'center',
            },
          }}
        >
          <TextField source="supervisionProjectId" label="Project ID" size={2.5} />
          <TextField source="davinciProjectId" label="DaVinci project ID" size={2} />
          <ProjectComplianceStatusField source="complianceStatus" label="Status" size={2} />
          <NonCompliantReasonsField source="nonCompliantReasons" label="Non-compliant reasons" size={5} />
        </DataGridLayoutGrid>
      </ListPageLayout>
    </List>
  );
};

export default ProjectsComplianceListPage;
